import React, { useState } from 'react'
import './style.css'
import Logo from "../../Images/New/Products/easyOffice.webp"
import Button from '../../Components/ui/button';

const Hero = () => {

   const [isExpanded, setIsExpanded] = useState(false);

   const toggleExpand = () => {
     setIsExpanded(!isExpanded);
   };
  return (
    <>
      <div>
        <svg
          id="boss"
          preserveAspectRatio="xMidYMid slice"
          viewBox="10 10 80 80"
        >
          <path
            fill="#d6e5ff"
            className="out-top"
            d="M37-5C25.1-14.7,5.7-19.1-9.2-10-28.5,1.8-32.7,31.1-19.8,49c15.5,21.5,52.6,22,67.2,2.3C59.4,35,53.7,8.5,37-5Z"
          />
          <path
            fill="#b5d0ff"
            className="in-top"
            d="M20.6,4.1C11.6,1.5-1.9,2.5-8,11.2-16.3,23.1-8.2,45.6,7.4,50S42.1,38.9,41,24.5C40.2,14.1,29.4,6.6,20.6,4.1Z"
          />
          <path
            fill="#d6e5ff"
            className="out-bottom"
            d="M105.9,48.6c-12.4-8.2-29.3-4.8-39.4.8-23.4,12.8-37.7,51.9-19.1,74.1s63.9,15.3,76-5.6c7.6-13.3,1.8-31.1-2.3-43.8C117.6,63.3,114.7,54.3,105.9,48.6Z"
          />
          <path
            fill="#b5d0ff"
            className="in-bottom"
            d="M102,67.1c-9.6-6.1-22-3.1-29.5,2-15.4,10.7-19.6,37.5-7.6,47.8s35.9,3.9,44.5-12.5C115.5,92.6,113.9,74.6,102,67.1Z"
          />
        </svg>

        <div
          className={`relative min-h-screen flex justify-center items-center z-40 sm:mt-0 mt-20`}
        >
          <div
            className={`flex justify-between items-center px-3 w-full max-w-7xl ${
              isExpanded ? "sm:mt-[150px] pb-10" : ""
            } `}
          >
            <div className="text-center flex flex-col items-center">
              {/* <p className="mb-0 text-black text-3xl pb-5 font-semibold">
                EasyTDS
              </p> */}
              <img src={Logo} alt="Logo" className="w-[30%] sm:w-[20%] my-5" />
              <p className="mb-0 text-black text-3xl sm:text-5xl pb-5 font-extrabold">
                The Best TDS & TCS Return Filing Software
              </p>
              <p className="mb-0 text-black text-xl sm:text-4xl pb-5 font-semibold">
                Simplify the process of TDS filing
              </p>
              <p className="mb-0 text-black text-xl pb-5 sm:px-[200px]">
                EasyTDS is a module for TDS Management in{" "}
                <strong>EasyOFFICE Software.</strong> EasyTDS is a comprehensive
                software solution for managing TDS and TCS returns. With its
                easy-to-use interface and advanced automation tools, this
                software makes it simple for Chartered Accountants, Tax
                professionals and Corporates to manage their{" "}
                <strong>
                  TDS and TCS returns filing easily & efficiently.
                </strong>
              </p>
              {isExpanded && (
                <div>
                  <p className="mb-0 text-black text-xl pb-5 sm:px-[200px]">
                    This software offers a wide range of features, including
                    eTDS and eTCS quarterly returns - 24Q, 26Q, 27Q, 27EQ, 24G,
                    TDS and TCS certificates, eTDS correction returns, interest
                    calculation, online data tools, multiple analysis reports,
                    Bulk PAN verification and much more. Additionally, the
                    software provides the option to import data from Excel,
                    Consoor.txt files for the creation of client master and
                    generating correction returns. With these features,
                    EasyOFFICE - EasyTDS is the most Preferred & Powerful TDS
                    return filing software for professionals in the Tax
                    industry. All these desirable features and ease of use make
                    EasyOFFICE Software the leading choice of tax professionals.
                  </p>
                  <p className="mb-0 text-black text-xl pb-5 sm:px-[200px]">
                    EasyTDS is a top-class TDS software that offers a
                    user-friendly interface, it has been designed to make the
                    process of e-filing TDS and TCS returns & certificate
                    generation simple, accurate and fast. This software is
                    integrated with TRACES, Protean and Income Tax India,
                    ensuring that users can file their TDS returns error-free.
                  </p>
                </div>
              )}
              <div className="flex justify-center">
                <button
                  onClick={toggleExpand}
                  className="mb-8 text-lg cursor-pointer"
                >
                  {isExpanded ? "Show Less" : "Show More"}
                </button>
                <a
                  href="https://www.easyofficesoftware.com/tdssoftware"
                  className="flex ml-5"
                  target="_blank"
                  rel="noreferrer"
                >
                  <p className="text-lg font-semibold">Learn More</p>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="16"
                    fill="currentColor"
                    class="bi bi-arrow-right mt-[6px] ml-1"
                    viewBox="0 0 16 16"
                  >
                    <path
                      fill-rule="evenodd"
                      d="M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8"
                    />
                  </svg>
                </a>
              </div>
              <div className='flex flex-wrap justify-center'>
                <a
                  href="https://www.easyofficesoftware.com/bank_details"
                  target="_blank"
                  rel="noreferrer"
                >
                  <Button label={"Buy Now"} />
                </a>
                <a
                  href="https://www.easyofficesoftware.com/public/catalogue/EasyOFFICE-TDS.jpg"
                  target="_blank"
                  rel="noreferrer"
                  className="ml-5"
                >
                  <Button label={"Catalogue"} />
                </a>
                <a
                  href="https://www.easyofficesoftware.com/video"
                  target="_blank"
                  rel="noreferrer"
                  className="sm:ml-5 sm:my-0 my-3 px-6 py-2 bg-gradient-to-r from-[#686bff] to-[#00b812] text-white rounded-lg text-lg font-bold duration-200 transform hover:rounded-full hover:-translate-y-1 transition"
                >
                  Video Demo
                </a>
              </div>
            </div>
            {/* <div className="w-1/2 p-10">
              <img src={BG} alt="" />
            </div> */}
          </div>
        </div>
      </div>
    </>
  );
}

export default Hero